module.exports = __webpack_public_path__ + "8cf748c7b1453d89cf02c47b120b46f6.pdf";